// extracted by mini-css-extract-plugin
export var box = "YoutubePlayer-module--box--7421a";
export var box_md = "YoutubePlayer-module--box_md--0359f";
export var box_xmd = "YoutubePlayer-module--box_xmd--be475";
export var box_flex = "YoutubePlayer-module--box_flex--159f8";
export var box_lg = "YoutubePlayer-module--box_lg--9a8be";
export var box_sm = "YoutubePlayer-module--box_sm--427f0";
export var box_outer = "YoutubePlayer-module--box_outer--1febb";
export var box_whiteBg = "YoutubePlayer-module--box_white-bg--b5fc2";
export var box_noMarginBottom = "YoutubePlayer-module--box_no-margin-bottom--80016";
export var box_noPadding = "YoutubePlayer-module--box_no-padding--6d9aa";
export var box_outerGray = "YoutubePlayer-module--box_outer-gray--cfe82";
export var box_dark = "YoutubePlayer-module--box_dark--6568f";
export var box_zIndex = "YoutubePlayer-module--box_z-index--8a11c";
export var box_zIndex6 = "YoutubePlayer-module--box_z-index-6--3b9b2";
export var box_eventsWithLine = "YoutubePlayer-module--box_events-with-line--bb9ce";
export var box_featuresAo = "YoutubePlayer-module--box_features-ao--9833b";
export var box_verticalPaddings = "YoutubePlayer-module--box_vertical-paddings--fcb6a";
export var clearP = "YoutubePlayer-module--clearP--901a7";
export var clearP_vc = "YoutubePlayer-module--clearP_vc--72116";
export var mediaPlayer = "YoutubePlayer-module--media-player--f81f2";
export var modal = "YoutubePlayer-module--modal--7b790";
export var video = "YoutubePlayer-module--video--e1f20";
export var buttonPause = "YoutubePlayer-module--button-pause--57503";
export var fadeInAnimation = "YoutubePlayer-module--fadeInAnimation--38064";
export var placeHolderShimmer = "YoutubePlayer-module--placeHolderShimmer--7bbda";